import * as React from 'react';

// tslint:disable:max-line-length
export const SignalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M6 4v2c1.7 0 3 1.3 3 3h2c0-2.8-2.2-5-5-5z" />
      <path d="M6 0v2c3.9 0 7 3.1 7 7h2c0-5-4-9-9-9zM6 8H2c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1z" />
    </g>
  </svg>
);
